import { createSelector } from "@reduxjs/toolkit";
import { PREFECTURES } from "../../constants/prefectures";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.store;

export const storeSelectors = {
  allStores: createSelector(selector, (state) => state.allStores),
  favoriteStores: createSelector(selector, (state) => state.favoriteStores),
  allPrefectures: createSelector(selector, (state) => state.prefectures),
  selectablePrefectures: createSelector(selector, (state) => {
    const prefecturesWithCities = Object.keys(state.prefectures).filter(
      (key) => state.prefectures[key].length > 0,
    );

    // Sort (by code), if not found, sort to last
    return prefecturesWithCities.sort((a, b) => {
      const prefectureA = PREFECTURES.find((p) => p.name === a);
      const prefectureB = PREFECTURES.find((p) => p.name === b);

      const aNotFound = !prefectureA;
      const bNotFound = !prefectureB;

      if (aNotFound && bNotFound) return 0; // both not in list, keep order
      if (aNotFound) return 1; // a not found, sort after b
      if (bNotFound) return -1; // b not found, sort after a

      return prefectureA.code - prefectureB.code;
    });
  }),
};
